// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminAiUsage = (client) => ({
    /**
     * `GET /admin/ai-usage`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetAiUsageByVendor
     * @source packages/medusa-plugin-ai-usage/src/api/admin/ai-usage/route.ts
     */
    list: (query, headers) => client.fetch("/admin/ai-usage", { method: "GET", query, headers }),
});
//# sourceMappingURL=ai-usage.js.map